<template>
  <div class="b-content">
    <swiper ref="mySwiper" :options="swiperOptions">
      <swiper-slide v-for="(item,index) in colorTarArr" :key="item.code"
                    :class="{'swiper-slide-active-item':item.code === selectInterCode}">
        <div class="slide-content swiper-no-swiping" @click="switchColor(index, item.code)">
          <div class="color">
            <div class="color-inner" :style="{background:`${item.color}`}">
              <template v-if="Array.isArray(item.color)">
                <span class="img-child" v-for="c in item.color" :key="c" :style="{background:`${c}`}"></span>
              </template>
            </div>
          </div>
          <div class="name">{{ item.name }}</div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="number360d"></div>

    <div class="position-box" :class="{open:positionOpen}" v-if="carConfig.interUseImg">
      <div class="position-arrow cont" :class="{'arrow-r':positionOpen}" @click="positionOpen=!positionOpen"></div>
      <div class="position-label" @click="positionOpen=!positionOpen">
        <div class="position-360 position-flex">
          <div class="icon cont">

          </div>
          <p class="label">选择视角</p>
        </div>
      </div>
      <template v-if="positionOpen">
        <div class="position-item position-flex" v-for="key in interPositionArr" :key="key"
             @click="()=>setSelectInterPositionCode(key)">
          <div class="icon-box" :class="{active:selectInterPositionCode===key}">
            <div class="icon cont" :class="key"></div>
          </div>
          <div class="label">{{ interPositionNameTar[key] }}</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import requireJson from "@/utils/requireJson";

export default {
  name: "outer",
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    },
    ...mapGetters(['selectTypeItem']),
    ...mapState({
      selectInterCode: state => state.selectInterCode,
      carConfig: state => state.carConfig,
      interArr: state => state.interArr,
      interPositionTar: state => state.interPositionTar,
      selectInterPositionCode: state => state.selectInterPositionCode,
    }),
    interPositionArr: vm => Object.keys(vm.interPositionTar),
    interCodeMap(){
      const target={}
      Object.entries(this.carConfig.interTypeArr||{}).forEach(([key, val]) => {
        const value= {key,...val}
        target[key] = value
        if(value.mapCodeArr){
          value.mapCodeArr.forEach((item) => {
            target[item] = value
          })
        }
      })
      return target
    },
    colorTarArr: vm =>
        vm.interArr.map(code => ({
          code,
          ...((vm.interCodeMap[code] || vm.globalInterTypeArr.find(o => o.code === code))||{})
        }))
  },
  // watch: {
  //   interArr: {
  //     handler() {
  //       this.colorTarArr = this.interArr.map(code => {
  //         let data = {
  //           code,
  //           ...((this.carConfig.interTypeArr && this.carConfig.interTypeArr[code]) || interTypeArr.find(o => o.code === code))
  //         }
  //         return data
  //       })
  //     },
  //     immediate: true
  //   }
  // },
  mounted() {
    const index = this.interArr.findIndex(o => o === this.selectInterCode)
    console.log(index)
    this.swiper.slideTo(index);

    requireJson('inter.json').then(globalInterTypeArr => {
      this.globalInterTypeArr = globalInterTypeArr
    })
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: '8',//显示个数
        direction: 'horizontal',
        centerInsufficientSlides: true,
        breakpoints: {
          768: {  //当屏幕宽度大于等于768
            slidesPerView: 4,
          }
        },
        normalizeSlideIndex: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        noSwiping: true
      },
      globalInterTypeArr: [],
      positionOpen: true,
      interPositionNameTar: {
        main: '主驾驶',
        back: '后排',
        copilot: '副驾驶'
      }
    }
  },
  methods: {
    ...mapActions(['setSelectInterCode', 'setSelectInterPositionCode']),
    switchColor(index, code) {
      console.log(index, code)
      this.swiper.slideTo(index);
      this.setSelectInterCode(code)
    }
  }
}
</script>

<style scoped lang="less">

@media (max-width: 960px)  {
  .position-box{
    zoom: 0.6 !important;
    top: -160px !important;
  }
}

.cont {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.position-box {
  zoom: 0.8;
  height: 100%;
  width: 206px;
  transition: all 0.2s;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  flex-direction: row;
  overflow: hidden;
  z-index: 2;

  &.open {
    width: 456px;
  }

  .position-arrow {
    width: 30px;
    height: 30px;
    background-image: url("../static/img/inter-arrow-l.png");
    cursor: pointer;

    &.arrow-r {
      background-image: url("../static/img/inter-arrow-r.png");
    }
  }

  .position-flex {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .position-360 {
    margin-left: 11px;
    width: 98px;
    height: 85px;
    margin-top: 22px;

    .icon {
      width: 38px;
      height: 38px;
      background-image: url("../static/img/inter-position.png");
    }

    .label {
      color: #FFF;
      text-align: center;
      font-family: MHeiGB;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      height: 36px;
      line-height: 36px;
    }
  }

  .position-item {
    width: 48px;
    margin-left: 35px;

    .icon-box {
      width: 38px;
      height: 38px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 11px;

      &.active {
        border-radius: 50%;
        border: 1px solid white;
      }

      .icon {
        width: 28px;
        height: 28px;

        &.main {
          background-image: url("../static/img/inter-main.png");
        }

        &.back {
          background-image: url("../static/img/inter-back.png");
        }

        &.copilot {
          background-image: url("../static/img/inter-copilot.png");
        }
      }
    }

    .label {
      color: #FFF;

      text-align: center;
      font-family: MHeiGB;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
    }
  }
}

</style>
